<nb-card>
  <nb-card-header>
    @if (disableDownload) {
      {{ "Energy/Carbon report" | translate }}
    } @else {
      {{ "Download report" | translate }}
    }
  </nb-card-header>
  <nb-card-body>

    @if (loading) {
      <div class="dl-div">
        <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
      </div>
    } @else {
        @if (!downloading && !disableDownload) {
          <div>
            @if (template?.specific_data?.displayScenarioSelector) {
              <div class="form-group mb-3">
                {{"Current plan VS" | translate}}
                <nb-select name="scenario" required [(ngModel)]="scenario"
                  [placeholder]="'choose a comparison scenario' | translate">
                  <nb-option [value]="null">-</nb-option>
                  @for (scenar of scenarii; track scenar) {
                    <nb-option [value]="scenar">{{ scenar.name }}</nb-option>
                  }
                </nb-select>
              </div>
            }
            <div class="form-group d-flex align-items-center mb-3">
              <div>{{ scopeString }}</div>
            </div>
            <div class="form-group d-flex align-items-center mb-3">
              <div class="me-2">{{ "Indicate period" | translate }}</div>
              <app-year-selector [(year)]="startYear" (yearChanged)="startYearChanged($event)"></app-year-selector>
              <span>&nbsp;-&nbsp;</span>
              <app-year-selector [(year)]="endYear" (yearChanged)="endYearChanged($event)"></app-year-selector>
            </div>
            @if (template?.specific_data?.displayPerimeterSelectors) {
              <div class="form-group d-flex align-items-center mb-3">
                <div class="me-2">{{ "Indicate perimeter type" | translate }}</div>
                <nb-select
                  style="width: 20rem;"
                  name="cluster"
                  [multiple]="true"
                  [(ngModel)]="selectedPerimeterTypesDisplay"
                  (ngModelChange)="onDisplaySelectionChanged($event)"
                >
                  <nb-option [value]="null">-</nb-option>
                  <nb-option [value]="ALL_OPTION_VALUE">{{ 'All' | translate }}</nb-option>
                  @for (pT of perimeterTypes; track pT) {
                    <nb-option [value]="pT">{{ pT.name }}</nb-option>
                  }
                </nb-select>
              </div>
              <div class="form-group d-flex align-items-center mb-3">
                <div class="me-2">{{ (isSingleSite ? "Buildings" : "Perimeter name") | translate }}</div>
                <nb-select
                  style="width: 20rem;"
                  name="levelOneSubPerimeters"
                  [multiple]="true"
                  [(ngModel)]="selectedLevelOneSubPerimetersDisplay"
                  (ngModelChange)="onPerimeterDisplaySelectionChanged($event)"
                  [placeholder]="'Select perimeters' | translate"
                >
                  <nb-option [value]="ALL_OPTION_VALUE">{{ (isSingleSite ? 'Whole site' : 'All') | translate }}</nb-option>
                  @for (perimeter of filteredLevelOneSubPerimeters(); track perimeter) {
                    <nb-option [value]="perimeter" [disabled]="isPerimeterDisabled(perimeter)">{{ perimeter.name }}</nb-option>
                  }
                </nb-select>
              </div>
            }
            <div class="btn-group">
              <button class="btn no" (click)="close()">{{ "Cancel" | translate }}</button>
              <button [disabled]="!canDownload()" class="btn" (click)="download()">{{ "Download" | translate }}</button>
            </div>
          </div>
        }

        @if (downloading && !disableDownload) {
          <div>
            <div class="dl-label">
              {{ "Downloading" | translate}}
            </div>
            <div class="dl-icon">
              <fa-icon icon="circle-notch" [spin]="true" size="lg" class="fa-spin"></fa-icon>
            </div>
          </div>
        }

        @if (disableDownload) {
          <div>
            <div class="dl-div">
              {{ "This report cannot be edited as there is no energy data on the selected site" | translate }}
            </div>
            <div class="btn-group">
              <button class="btn" (click)="close()">OK</button>
            </div>
          </div>
        }
    }


  </nb-card-body>
</nb-card>
